export type MapStyleKey =
  | 'street'
  | 'dark'
  | 'terrain'
  | 'satellite'
  | 'coastal_earth'
  | 'cardo'
  | 'alpine'
  | 'desert'

export interface MapStyle {
  key: MapStyleKey
  labelKey: string
  path: string
  isPro: boolean
  usesShippedRouteSource: boolean
  // Whether overlay elements we draw ourselves (e.g. the route line on styles
  // that don't ship their own) should be light-colored to contrast a dark map.
  prefersLightElements: boolean
  previewImage: string
}

const MAP_STYLES: MapStyle[] = [
  {
    key: 'street',
    labelKey: 'map_style_street',
    path: 'RISER-Street',
    isPro: false,
    usesShippedRouteSource: false,
    prefersLightElements: false,
    previewImage: '/images/map-styles/street.png'
  },
  {
    key: 'dark',
    labelKey: 'map_style_dark',
    path: 'RISER-Dark',
    isPro: false,
    usesShippedRouteSource: false,
    prefersLightElements: true,
    previewImage: '/images/map-styles/dark.png'
  },
  {
    key: 'terrain',
    labelKey: 'map_style_terrain',
    path: 'RISER-Terrain',
    isPro: false,
    usesShippedRouteSource: false,
    prefersLightElements: false,
    previewImage: '/images/map-styles/terrain.png'
  },
  {
    key: 'satellite',
    labelKey: 'map_style_satellite',
    path: 'RISER-Sat-V2',
    isPro: true,
    usesShippedRouteSource: false,
    prefersLightElements: true,
    previewImage: '/images/map-styles/satellite.png'
  },
  {
    key: 'coastal_earth',
    labelKey: 'map_style_coastal_earth',
    path: 'RISER-CoastalEarth',
    isPro: true,
    usesShippedRouteSource: true,
    prefersLightElements: false,
    previewImage: '/images/map-styles/coastal-earth.png'
  },
  {
    key: 'cardo',
    labelKey: 'map_style_cardo',
    path: 'RISER-Cardo',
    isPro: true,
    usesShippedRouteSource: true,
    prefersLightElements: true,
    previewImage: '/images/map-styles/cardo.png'
  },
  {
    key: 'alpine',
    labelKey: 'map_style_alpine',
    path: 'RISER-Alpine',
    isPro: true,
    usesShippedRouteSource: true,
    prefersLightElements: true,
    previewImage: '/images/map-styles/alpine.png'
  },
  {
    key: 'desert',
    labelKey: 'map_style_desert',
    path: 'RISER-Desert',
    isPro: true,
    usesShippedRouteSource: true,
    prefersLightElements: false,
    previewImage: '/images/map-styles/desert.png'
  }
]

export default function () {
  const config = useRuntimeConfig()

  const baseUrl = (config.public.mapStyleBaseUrl as string) ?? '/'

  const styleUrl = (path: string) => `${baseUrl}${path}/style.json`

  const getStyle = (key: MapStyleKey) => {
    return MAP_STYLES.find((style) => style.key === key) ?? MAP_STYLES[0]
  }

  const getStyleUrl = (key: MapStyleKey) => {
    return styleUrl(getStyle(key).path)
  }

  return {
    styles: MAP_STYLES,
    styleUrl,
    getStyle,
    getStyleUrl
  }
}
